import React from "react";

const UserSearch = ({
  search,
  setSearch,
  statusFilter,
  setStatusFilter,
  customerId,
  setCustomerId,
  subscriptionStatuses,
  fetchUsers,
  loading,
  message
}) => {
  const handleSearch = () => {
    fetchUsers(search, statusFilter, customerId); 
  };

  return (
    <div className="mb-6">
      <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-6 bg-white p-6 rounded-lg shadow-lg">
        <div className="relative flex-1 w-full">
          <input
            type="text"
            placeholder="Search by name or email"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full border border-gray-300 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400 transition-shadow shadow-md"
          />
        </div>

        <div className="relative flex-1 w-full">
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="w-full border border-gray-300 p-3 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-400 transition-shadow shadow-md"
          >
            <option value="">All Statuses</option>
            {subscriptionStatuses.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </div>

        <div className="relative flex-1 w-full">
          <input
            type="text"
            placeholder="Search by Customer ID"
            value={customerId}
            onChange={(e) => setCustomerId(e.target.value)}
            className="w-full border border-gray-300 p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400 transition-shadow shadow-md"
          />
        </div>

        <button
          onClick={handleSearch}
          className="px-6 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-md shadow-lg hover:shadow-xl transition-shadow hover:from-blue-600 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-400 disabled:opacity-50"
          disabled={loading}
        >
          {loading ? (
            <span className="animate-pulse">Searching...</span>
          ) : (
            "Search"
          )}
        </button>
      </div>

      {/* Display message for search result */}
      {message && (
        <p className="mt-4 text-center text-sm text-gray-500">{message}</p>
      )}
    </div>
  );
};

export default UserSearch;
